import React, { Component } from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './SynonymTag.css';

class SynonymTag extends Component {

  static defaultProps = {
    synonym : "",
    isEdit : false,
    allowDelBtn : false,
    isForView : false,
  }

  state = {
    showDelBtn : false,
  }

  // handleKeyPressInput = (e) => {
  //   if (e.key === 'Enter') {
  //     this.props.editSynonym(this.props.id, e.target.value);
  //   }
  // }

  handleClickDelBtn = (e) => {
    this.props.deleteSynonym(this.props.id);
    e.stopPropagation();
  }

  // Synonym 수정 인풋 onChange 핸들링
  handleChangeInput = (e) => {
    /**
     * synonymEntity의 name 상속 Synonym으로 인해 index가 1씩 밀리는데,
     * 실제 데이터는 index를 0부터 시작하여 -1 처리
     */
    this.props.editSynonym(this.props.id, e.target.value);
  }

  render() { 
    const synonymClass = classnames({
      "synonym" : true,
      "edit" : this.props.isEdit,
      "for-view" : this.props.isForView,
    })

    const delBtnClass = classnames({
      "delete-btn" : true,
      "hide" : !this.state.showDelBtn || !this.props.allowDelBtn || !this.props.isEdit,
      "on-edit-mode" : this.props.isEdit,
    })

    const inputClass = {
      width : displayTextWidth(this.props.synonym, "italic 16px verdana"),
      backgroundColor : 'transparent',
      border : 'none',
      marginBottom : '0px',
      // width : 5,
    }

    return (
      <div className={synonymClass}
        onClick={(e) => {e.stopPropagation()}}
        onMouseEnter={() => {
          this.setState({
            showDelBtn : true,
          })
        }}
        onMouseLeave={() => {
          this.setState({
            showDelBtn : false,
          })
        }}
        title={ !this.props.allowDelBtn && !this.props.isForView ? 
          "이름 상속 Synonym(삭제할 수 없음)" : 
          "Synonym"}> {/* view tag인 경우 Title을 'Synonym'으로 통일 표기 */}
        {
          this.props.isEdit && this.props.allowDelBtn ? (
            <input style={inputClass}
              value={this.props.synonym}
              onChange={this.handleChangeInput}
              // onKeyPress={this.handleKeyPressInput}
            />
          ) : (
            <p> {this.props.synonym} </p>
          )
        }
        {
          !this.props.isForView && (
            <button className={delBtnClass}
              onClick={this.handleClickDelBtn} >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          ) 
        }
      </div>
    );
  }
}

const displayTextWidth = (text, font) => {
  var myCanvas = displayTextWidth.canvas || (displayTextWidth.canvas = document.createElement("canvas"));
  var context = myCanvas.getContext("2d");
  context.font = font;
  
  var metrics = context.measureText(text);
  return metrics.width;
};

export default SynonymTag;